import styled from 'styled-components';

// CONSTANTS
import colors, { WHITE, SANTAS_GRAY } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

const { checkboxCard } = colors;

export const Container = styled.div`
  &.carousel-select-apps,
  .carousel-select-apps {
    &__title {
      margin-bottom: 10px;

      .title {
        cursor: pointer;
      }
    }
  }
`;

export const CarouselWrapper = styled.div`
  && {
    .swiper-container {
      padding: 0;

      ${breakpoints.down('xs')} {
        overflow: visible;
      }
    }
  }

  .card-wrapper {
    &--see-all {
      margin: 12px 0;

      .dummy-card {
        position: relative;
        background-color: ${WHITE};
        border-radius: 6px;
        height: 88px;
        box-shadow: 0 1px 3px ${checkboxCard.shadow};
        border: 1px solid ${checkboxCard.border};
        cursor: pointer;

        &:hover {
          border-color: ${p => p.theme.palette.primary.main || colors.primary};

          ${breakpoints.down('xs')} {
            border-color: ${checkboxCard.border};
          }
        }

        &__content {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;

          i {
            font-size: 22px;
            color: ${SANTAS_GRAY};
            margin-bottom: 8px;
          }

          span {
            color: ${p => p.theme.palette.text.primary};
          }
        }
      }
    }

    .checkbox-card {
      margin-left: 0;
      margin-right: 0;
      background-color: ${WHITE};
    }
  }

  .stage-carousel {
    padding-top: 0;
  }

  .swiper-slide {
    ${breakpoints.down('md')} {
      width: 110px;
    }
  }
`;

export default Container;
